/*
Copyright 2023 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

/**
 * Errors expected to be encountered during OAuth2 discovery, client registration, and authentication.
 * Not intended to be displayed directly to the user.
 */
export let OAuth2Error = /*#__PURE__*/function (OAuth2Error) {
  OAuth2Error["General"] = "Something went wrong with OAuth2 discovery";
  OAuth2Error["OpSupport"] = "Configured OAuth2 OP does not support required functions";
  OAuth2Error["DynamicRegistrationNotSupported"] = "Dynamic registration not supported";
  OAuth2Error["DynamicRegistrationFailed"] = "Dynamic registration failed";
  OAuth2Error["DynamicRegistrationInvalid"] = "Dynamic registration invalid response";
  OAuth2Error["CodeExchangeFailed"] = "Failed to exchange code for token";
  OAuth2Error["InvalidBearerTokenResponse"] = "Invalid bearer token response";
  OAuth2Error["InvalidDeviceAuthorizationResponse"] = "Invalid device authorization response";
  OAuth2Error["MissingOrInvalidStoredState"] = "State required to finish logging in is not found in storage.";
  OAuth2Error["RefreshTokenFailed"] = "Failed to refresh token";
  OAuth2Error["RevokeTokenFailed"] = "Failed to revoke token";
  OAuth2Error["DeviceAuthorizationGrantFailed"] = "Failed to perform device authorization grant";
  return OAuth2Error;
}({});
//# sourceMappingURL=error.js.map